
import React, { useState, useContext } from 'react'
import { FormControl, Select, MenuItem, InputLabel, FormHelperText, Typography, FormControlLabel, Checkbox } from '@mui/material';
import customStyles from "../../../../assets/styles/customStyles";
import clsx from 'clsx';
import Down from "../Icons/Down";
import Up from "../Icons/Up";

import { Context } from "../Wrapper";


export const FilterSelect = props => {
    const { defaultValue, onChange, details, heads, parentClasses, customClasses, id } = props;
    const [visible, setVisible] = useState(true);
    const classes = customStyles();
    return (
        <FormControl className={parentClasses}>
            <Select
                IconComponent={visible ? Down : Up}
                value={defaultValue}
                displayEmpty
                id={id}
                onOpen={(e) => setVisible(false)}
                onClose={(e) => setVisible(true)}
                onChange={(e) => onChange(e)}
                fullWidth
                className={customClasses}
                MenuProps={{
                    classes: { paper: classes.dropdownStyle },
                    variant: 'menu',
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left"
                    },
                    transformOrigin: {
                        vertical: "top",
                        horizontal: "left"
                    }
                }}>
                {details && details?.length > 0 && details?.map((values, i) =>
                    <MenuItem key={i} value={values[heads[0]]}>{values[heads[1]]}</MenuItem>
                )}
            </Select>
        </FormControl>
    )
}

export const CustomSelect = props => {
    const { defaultValue, details, displayEmpty,
        error, fieldName, disabled = false,
        heads, onChange, name, parentClasses, lableClasses, customClasses } = props;
    const [visible, setVisible] = useState(true);
    const classes = customStyles();


    return (
        <FormControl
            className={parentClasses}
            fullWidth
            variant={'standard'}>
            {
                name && <InputLabel shrink={displayEmpty} className={lableClasses} error={error && true}>
                    {name} </InputLabel>
            }
            <Select
                className={customClasses}
                IconComponent={visible ? Down : Up}
                disabled={disabled}
                value={defaultValue}
                name={fieldName}
                onOpen={(e) => setVisible(false)}
                onClose={(e) => setVisible(true)}
                onChange={(e) => onChange(e)}
                error={error && true}
                displayEmpty={displayEmpty}
                MenuProps={{ classes: { paper: classes.dropdownStyle } }}>
                {
                    displayEmpty && <MenuItem value={""}>{"Select Role"}</MenuItem>
                }
                {details && details?.length > 0 && details?.map((values, i) =>
                    <MenuItem key={i} value={values[heads[0]]}>{values[heads[1]]}</MenuItem>
                )}
            </Select>
            {error ? <FormHelperText className={clsx(classes.colorRed)}>{error}</FormHelperText> : ''}

        </FormControl>
    )
}

export const NormalSelect = props => {
    const { signedIn, margin10t, id, signedInId } = props;
    const [visible, setVisible] = useState(true);
    const context = useContext(Context);
    //const [language, setLanguage] = useState('en-US');
    const language = 'en-US';
    const classes = customStyles();
    return (
        <Typography
            className={clsx(margin10t, classes.fonSize13, classes.changeLanguage)}
            variant={'subtitle1'}>
            <span className={clsx(classes.color, classes.bold, classes.fonSize13, classes.mobileDisplay)}>
                Change Language?
            </span>
            <Select
                label="lang"
                id={id}
                value={context.locale}
                variant={'standard'}
                onChange={context.selectLanguage}
                sx={{ margin: '0 10px', minWidth: "65px" }}
                className={clsx(classes.selectOptions, classes.fonSize13, classes.dropDownHighlight)}
                IconComponent={visible ? Down : Up}
                onOpen={() => setVisible(false)}
                onClose={() => setVisible(true)}
                disableUnderline
                MenuProps={{
                    classes: { paper: classes.dropdownStyle },
                    variant: 'menu',
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left"
                    },
                    transformOrigin: {
                        vertical: "top",
                        horizontal: "left"
                    }
                }}>
                <MenuItem value={context.locale.includes("en") ? context.locale : language}>English</MenuItem>
                <MenuItem value={"ta"}>தமிழ்</MenuItem>
            </Select>
            {
                signedIn && <FormControlLabel control={<Checkbox defaultChecked id={signedInId} />} className={clsx(classes.fonSize13, classes.staySigned)} style={{ float: "right" }} label={<span className={clsx(classes.fonSize13)}>
                    Stay Signed In
                </span>} />
            }
        </Typography>
    )
}

